import CONFIG from 'Config/settings';

export default class PostCodeNLApiClient {
  constructor() {
    this.apiUrl = CONFIG.API.ADDRESS_AUTOCOMPLETE.HOST;
    this.countryCode = CONFIG.COUNTRY;
    this.languageCode = CONFIG.LANGUAGE;
    this.addressFieldMap = CONFIG.ADDRESS_AUTOCOMPLETE.FIELD_MAP;
    this.addressValueMap = CONFIG.ADDRESS_AUTOCOMPLETE.VALUE_MAP;
  }

  async getAddress(houseNumber, postCode) {
    const requestBody = {
      country: this.countryCode,
      language: this.languageCode,
      postCode,
      houseNumber
    };
    return fetch(this.apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-client-id': `${CONFIG.API.ADDRESS_AUTOCOMPLETE.CLIENT_ID}`
      },
      body: JSON.stringify(requestBody)
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        return [];
      })
      .then(json => {
        return json;
      })
      .catch(_e => {
        return [];
      });
  }

  async filter(searchData, successCallback) {
    if (!searchData.houseNumber || !searchData.zipCode) {
      successCallback();
    } else {
      const data = await this.getAddress(
        searchData.houseNumber,
        searchData.zipCode
      );
      successCallback({
        address1: data.addressLine1
          ? data.addressLine1?.match(/^[^0-9]+/)[0]?.trim()
          : searchData.address1,
        cityName: data.city ? data.city : searchData.cityName
      });
    }
  }
}
